import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Append-only audit log — Ley 2015/2020 compliance.
 * Never reads, updates, or deletes entries.
 */
export async function logAudit(accion, entidad, entidadId, userId, userEmail, detalles = "", hashAntes = null, hashDespues = null) {
  try {
    await addDoc(collection(db, "audit_log"), {
      accion,
      entidad,
      entidadId: entidadId || "",
      userId: userId || "",
      userEmail: userEmail || "",
      detalles,
      hashAntes,
      hashDespues,
      timestamp: serverTimestamp(),
    });
  } catch (err) {
    console.error("Audit log write failed:", err);
  }
}
